import React, { useState } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../helpdesk/StatusBar.css';
import './ManufacturingStatusBar.css';

const ESTATUS = [
  'Pendiente',
  'Producción',
  'Empaque',
  'Despachado',
  'Facturado',
];

/**
 * Barra de estados de manufactura.
 * currentStep es 0-based (status DB 0–4). Status 5 (Anulado) se muestra aparte.
 * Cualquier paso es clickeable si canEdit.
 */
const ManufacturingStatusBar = ({ currentStep = 0, onStepClick, canEdit = false, cancelled = false }) => {
  const [hoveredStep, setHoveredStep] = useState(null);
  const numericStep = Number(currentStep);
  const isCancelled = cancelled || numericStep === 5;
  const safeStep = isCancelled
    ? -1
    : Math.max(0, Math.min(ESTATUS.length - 1, Number.isFinite(numericStep) ? numericStep : 0));
  const progressPercentage = safeStep < 0 ? 0 : (safeStep / (ESTATUS.length - 1)) * 100;
  const allowEdit = canEdit && !isCancelled;

  const handleStepClick = (stepIndex) => {
    if (!allowEdit) return;
    if (stepIndex === safeStep) return;
    onStepClick?.(stepIndex, ESTATUS[stepIndex]);
  };

  return (
    <div className={`status-bar-container manufacturing-status-bar my-3${isCancelled ? ' is-cancelled' : ''}`}>
      <div className="status-bar-progress" style={{ width: `${progressPercentage}%` }} />
      <div className="status-bar-nodes">
        {ESTATUS.map((status, index) => {
          const isCompleted = !isCancelled && index < safeStep;
          const isActive = !isCancelled && index === safeStep;
          const isPreview = allowEdit && hoveredStep === index && index !== safeStep;
          const circleClasses = `node-circle 
            ${isCompleted || isPreview ? 'completed' : ''} 
            ${isActive ? 'active' : ''}
            ${isCancelled ? 'cancelled-node' : ''}
          `;
          const nodeClasses = `status-node ${allowEdit && index !== safeStep ? 'clickable' : ''}`;

          return (
            <div
              className={nodeClasses}
              key={status}
              onClick={() => handleStepClick(index)}
              onMouseEnter={() => allowEdit && setHoveredStep(index)}
              onMouseLeave={() => allowEdit && setHoveredStep(null)}
            >
              <div className={circleClasses}>
                {(isCompleted || isPreview) && <i className="bi bi-check" />}
                {isActive && <div className="inner-circle" />}
                {isCancelled && <i className="bi bi-x" />}
              </div>
              <div className="node-label">{status}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ManufacturingStatusBar;
export { ESTATUS as MANUFACTURING_STATUS_STEPS };
